export enum ColdHandoffStatus {
  NONE = 'NONE',
  REQUESTED = 'REQUESTED',
  ACCEPTED = 'ACCEPTED',
}
